export const RoleEnum = {
    SuperAdministrador: 'SuperAdministrador',
    Administrador: 'Administrador',
    Usuario: 'Usuario',
}